import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import Swal from 'sweetalert2';
import * as jsonManager from '../../../abis/Manager.json';
import { environment } from '../../../../environments/environment';
import { ConnectionsService } from '../../../services/connectionsWeb3/connections.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-proyect-set-data', 
  templateUrl: './proyect-set-data.component.html',
  styleUrls: ['./proyect-set-data.component.css']
})
export class ProyectSetDataComponent implements OnInit {
  @Input() proyect: any;
  @Output() close = new EventEmitter<boolean>();

  formNewNft: FormGroup = this.createFormNewNft();
  fotoMain: string | null = null;
  foto1: string | null = null;
  foto2: string | null = null;
  foto3: string | null = null;
  foto4: string | null = null;
  foto5: string | null = null;
  foto6: string | null = null;
  foto7: string | null = null;
  foto8: string | null = null;
  foto9: string | null = null;
  foto10: string | null = null;
  whitePaper: string | null = null;
  dosier: string | null = null;
  infoToken: string | null = null;
  loadingFlag: boolean = false;

  // Propiedades para manejar proyectos en blockchain
  projectInBlockchain: boolean = false;
  readonlyFields: string[] = [];

  ourAddress: string | undefined;
  web3: any | undefined;
  abiManager: any = jsonManager;
  contractManager: any | undefined;

  readonly ordenAtributos = ["Habitaciones", "Baños", "Cocina", "Comedor", "Garaje"];
  
  // Variables para manejar viviendas múltiples
  viviendasArray: FormArray<FormGroup>;
  primeraVivienda: FormGroup = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    atributos: new FormControl('', [Validators.required])
  });

  constructor(
    private storage: AngularFireStorage,
    private afs: AngularFirestore,
    private connSrv: ConnectionsService,
    private cdr: ChangeDetectorRef
  ) {
    this.web3 = this.connSrv.web3Instance;

    this.connSrv.addressUser.subscribe((res: string) => {
      this.ourAddress = res;
    });

    this.contractManager = new this.web3.eth.Contract(this.abiManager.abi, environment.config.ADDRESS_MANAGER);
    
    // Inicializar FormArray
    this.viviendasArray = new FormArray<FormGroup>([]);
  }

  createFormNewNft() {
    return new FormGroup({
      titulo: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      promotora: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      pais: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      estadoCCAAProvincia: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      localidad: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      barrio: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      codigoPostal: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      calle: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      iframeGoogleMaps: new FormControl(null, [Validators.required]),
      descripcion: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      plazoEstimadoEntrega: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      rentabilidadAnual: new FormControl(0, [Validators.required, Validators.min(1)]),
      amountToSell: new FormControl(0, [Validators.required, Validators.min(1)]),
      precioToken: new FormControl(0, [Validators.required, Validators.min(0)]),
      inversionMinima: new FormControl(0, [Validators.required, Validators.min(1)]),
      stableCoinAddress: new FormControl('0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', [Validators.required]),
      beneficiaryAddress: new FormControl(null, [Validators.required]),
      aggregatorStableCoinDolar: new FormControl('0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D', [Validators.required]),
      urlWhitepaperPdf: new FormControl(null),
      urlDosierPdf: new FormControl(null),
      urlInfoTokenPdf: new FormControl(null),
      urlImagenPrincipal: new FormControl(null),
      toBlockchain: new FormControl(false),
      onlyInversors: new FormControl(false),
      percentageToPivateSale: new FormControl(75, [Validators.required, Validators.min(0), Validators.max(100)]),
      nameTokens: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      symbolTokens: new FormControl(null, [Validators.required, this.winAnsiValidator]),
      propertyType: new FormControl('House Flipping', [Validators.required]), // Tipo de propiedad
      infoProyecto: new FormControl(null, [this.urlValidator]),
      fechaActivado: new FormControl(null, [Validators.required]),
      managingInvestments: new FormControl(false),
      isMultipleVivienda: new FormControl(false), // Campo para identificar el tipo de proyecto
      atributos: new FormControl(null), // Campo para atributos únicos (formato antiguo)
      proyectStatus: new FormControl('En estudio', [Validators.required])
    })
  }

  get titulo() { return this.formNewNft?.get('titulo'); }
  get promotora() { return this.formNewNft?.get('promotora'); }
  get pais() { return this.formNewNft?.get('pais'); }
  get estadoCCAAProvincia() { return this.formNewNft?.get('estadoCCAAProvincia'); }
  get localidad() { return this.formNewNft?.get('localidad'); }
  get barrio() { return this.formNewNft?.get('barrio'); }
  get codigoPostal() { return this.formNewNft?.get('codigoPostal'); }
  get calle() { return this.formNewNft?.get('calle'); }
  get iframeGoogleMaps() { return this.formNewNft?.get('iframeGoogleMaps'); }
  get descripcion() { return this.formNewNft?.get('descripcion'); }
  get plazoEstimadoEntrega() { return this.formNewNft?.get('plazoEstimadoEntrega'); }
  get rentabilidadAnual() { return this.formNewNft?.get('rentabilidadAnual'); }
  get precioToken() { return this.formNewNft?.get('precioToken'); }
  get inversionMinima() { return this.formNewNft?.get('inversionMinima'); }
  get amountToSell() { return this.formNewNft?.get('amountToSell'); }
  get stableCoinAddress() { return this.formNewNft?.get('stableCoinAddress'); }
  get beneficiaryAddress() { return this.formNewNft?.get('beneficiaryAddress'); }
  get aggregatorStableCoinDolar() { return this.formNewNft?.get('aggregatorStableCoinDolar'); }
  get urlWhitepaperPdf() { return this.formNewNft?.get('urlWhitepaperPdf'); }
  get urlDosierPdf() { return this.formNewNft?.get('urlDosierPdf'); }
  get urlInfoTokenPdf() { return this.formNewNft?.get('urlInfoTokenPdf'); }
  get urlImagenPrincipal() { return this.formNewNft?.get('urlImagenPrincipal'); }
  get toBlockchain() { return this.formNewNft?.get('toBlockchain'); }
  get onlyInversors() { return this.formNewNft?.get('onlyInversors'); }
  get percentageToPivateSale() { return this.formNewNft?.get('percentageToPivateSale'); }
  get nameTokens() { return this.formNewNft?.get('nameTokens'); }
  get symbolTokens() { return this.formNewNft?.get('symbolTokens'); }
  get propertyType() { return this.formNewNft?.get('propertyType'); }
  get infoProyecto() { return this.formNewNft?.get('infoProyecto'); }
  get fechaActivado() { return this.formNewNft?.get('fechaActivado'); }
  get managingInvestments() { return this.formNewNft?.get('managingInvestments'); }
  get isMultipleVivienda() { return this.formNewNft?.get('isMultipleVivienda'); }
  get atributos() { return this.formNewNft?.get('atributos'); }
  get proyectStatus() { return this.formNewNft?.get('proyectStatus'); }

  // Método para manejar el cambio del checkbox de viviendas múltiples
  onMultipleViviendaChange(event: any) {
    const isMultiple = event.target.checked;
    
    if (isMultiple) {
      // Limpiar validaciones del campo atributos
      this.atributos?.clearValidators();
      this.atributos?.updateValueAndValidity();
      
      // Añadir validaciones a viviendas
      this.primeraVivienda.get('nombre')?.setValidators([Validators.required]);
      this.primeraVivienda.get('atributos')?.setValidators([Validators.required]);
      this.primeraVivienda.updateValueAndValidity();
      
      // Añadir validaciones a viviendas adicionales
      this.viviendasArray.controls.forEach(vivienda => {
        vivienda.get('nombre')?.setValidators([Validators.required]);
        vivienda.get('atributos')?.setValidators([Validators.required]);
        vivienda.updateValueAndValidity();
      });
    } else {
      // Limpiar validaciones de viviendas
      this.primeraVivienda.get('nombre')?.clearValidators();
      this.primeraVivienda.get('atributos')?.clearValidators();
      this.primeraVivienda.updateValueAndValidity();
      
      this.viviendasArray.controls.forEach(vivienda => {
        vivienda.get('nombre')?.clearValidators();
        vivienda.get('atributos')?.clearValidators();
        vivienda.updateValueAndValidity();
      });
      
      // Añadir validaciones al campo atributos
      this.atributos?.setValidators([Validators.required]);
      this.atributos?.updateValueAndValidity();
    }
  }

  // Método para ordenar atributos (formato antiguo)
  ordenarAtributos() {
    try {
      const atributosOrdenados = this.getAtributosJsonFromString(this.atributos?.value || '{}');
      
      const atributosString = `{${Object.entries(atributosOrdenados)
        .map(
          ([key, value]) =>
            `"${key}": ${typeof value === 'string' ? `"${value}"` : value}`
        )
        .join(', ')}}`;
      
      this.atributos?.setValue(atributosString);
    } catch (error) {
      console.error('Error en ordenarAtributos:', error);
    }
  }

  // Métodos para manejar viviendas múltiples
  getViviendaControl(index: number, field: string): FormControl {
    if (index === 0) {
      const control = this.primeraVivienda.get(field);
      if (!control) {
        // Si el control no existe, crear uno nuevo (no debería pasar pero por seguridad)
        const newControl = new FormControl('');
        this.primeraVivienda.addControl(field, newControl);
        return newControl;
      }
      return control as FormControl;
    } else {
      const vivienda = this.viviendasArray.at(index - 1);
      if (!vivienda) {
        throw new Error(`No existe la vivienda en el índice ${index - 1}`);
      }
      const control = vivienda.get(field);
      if (!control) {
        // Si el control no existe, crear uno nuevo (no debería pasar pero por seguridad)
        const newControl = new FormControl('');
        vivienda.addControl(field, newControl);
        return newControl;
      }
      return control as FormControl;
    }
  }

  anadirVivienda() {
    const nuevaVivienda = new FormGroup({
      nombre: new FormControl('', [Validators.required]),
      atributos: new FormControl('', [Validators.required])
    });
    this.viviendasArray.push(nuevaVivienda);
  }

  eliminarVivienda(index: number) {
    this.viviendasArray.removeAt(index);
  }

  ordenarAtributosVivienda(index: number) {
    try {
      let atributosControl: FormControl | null = null;
      
      if (index === 0) {
        atributosControl = this.primeraVivienda.get('atributos') as FormControl;
      } else {
        const vivienda = this.viviendasArray.at(index - 1);
        atributosControl = vivienda ? vivienda.get('atributos') as FormControl : null;
      }

      if (atributosControl) {
        const atributosOrdenados = this.getAtributosJsonFromString(atributosControl.value);
        
        const atributosString = `{${Object.entries(atributosOrdenados)
          .map(
            ([key, value]) =>
              `"${key}": ${typeof value === 'string' ? `"${value}"` : value}`
          )
          .join(', ')}}`;
        
        atributosControl.setValue(atributosString);
      }
    } catch (error) {
      console.error('Error en ordenarAtributosVivienda:', error);
    }
  }

  getAtributosJsonFromString(atributosString: string): Record<string, any> {
    const trimmedString = atributosString?.trim() || '{}';

    try {
      const sanitizedString =
        trimmedString.startsWith('{') && trimmedString.endsWith('}')
          ? trimmedString
          : `{${trimmedString}}`;

      // Parsear el JSON string
      const atributos = JSON.parse(sanitizedString);

      const atributosOrdenados: Record<string, any> = {};

      // Primero, añadir los atributos en un orden especifico
      this.ordenAtributos.forEach((key) => {
        if (key in atributos) {
          atributosOrdenados[key] = atributos[key];
          delete atributos[key];
        }
      });

      // Luego, añadir los atributos que quedan
      Object.assign(atributosOrdenados, atributos);

      return atributosOrdenados;
    } catch (error) {
      console.error("Error al analizar la cadena JSON en 'atributos':", error);
      return {};
    }
  }

  // Método para obtener todas las viviendas como array
  getAllViviendas(): Array<{nombre: string, atributos: Record<string, any>}> {
    const viviendas: Array<{nombre: string, atributos: Record<string, any>}> = [];
    
    // Añadir primera vivienda
    const primeraNombre = this.primeraVivienda.get('nombre')?.value;
    const primeraAtributos = this.getAtributosJsonFromString(this.primeraVivienda.get('atributos')?.value || '{}');
    if (primeraNombre) {
      viviendas.push({
        nombre: primeraNombre,
        atributos: primeraAtributos
      });
    }

    // Añadir viviendas adicionales
    this.viviendasArray.controls.forEach(vivienda => {
      const nombre = vivienda.get('nombre')?.value;
      const atributos = this.getAtributosJsonFromString(vivienda.get('atributos')?.value || '{}');
      if (nombre) {
        viviendas.push({
          nombre: nombre,
          atributos: atributos
        });
      }
    });

    return viviendas;
  }

  // Método para cargar viviendas existentes
  cargarViviendasExistentes() {
    // Limpiar viviendas existentes
    this.viviendasArray.clear();
    this.primeraVivienda.reset();

    // Determinar el tipo de proyecto basado en isMultipleVivienda
    const isMultipleVivienda = this.proyect.isMultipleVivienda === true;

    if (isMultipleVivienda && this.proyect.viviendas && Array.isArray(this.proyect.viviendas) && this.proyect.viviendas.length > 0) {
      // Proyecto con viviendas múltiples - cargar viviendas
      const primeraVivienda = this.proyect.viviendas[0];
      this.primeraVivienda.patchValue({
        nombre: primeraVivienda.nombre || '',
        atributos: this.formatAtributosToString(primeraVivienda.atributos || {})
      });

      // Cargar viviendas adicionales
      for (let i = 1; i < this.proyect.viviendas.length; i++) {
        const vivienda = this.proyect.viviendas[i];
        const nuevaVivienda = new FormGroup({
          nombre: new FormControl(vivienda.nombre || '', [Validators.required]),
          atributos: new FormControl(this.formatAtributosToString(vivienda.atributos || {}), [Validators.required])
        });
        this.viviendasArray.push(nuevaVivienda);
      }
    } else if (!isMultipleVivienda && this.proyect.attributes) {
      // Proyecto antiguo con atributos únicos - migrar a vivienda única
      let attributesString;
      if (typeof this.proyect.attributes === 'string') {
        attributesString = this.proyect.attributes;
      } else {
        attributesString = JSON.stringify(this.proyect.attributes);
      }

      if (attributesString.startsWith('{') && attributesString.endsWith('}')) {
        attributesString = attributesString.substring(1, attributesString.length - 1);
      }

      this.primeraVivienda.patchValue({
        nombre: 'Vivienda Principal',
        atributos: attributesString
      });
    } else {
      // Inicializar con vivienda vacía
      this.primeraVivienda.patchValue({
        nombre: '',
        atributos: ''
      });
    }
  }

  // Método para formatear atributos a string
  formatAtributosToString(atributos: Record<string, any>): string {
    if (!atributos || Object.keys(atributos).length === 0) {
      return '';
    }

    return `{${Object.entries(atributos)
      .map(
        ([key, value]) =>
          `"${key}": ${typeof value === 'string' ? `"${value}"` : value}`
      )
      .join(', ')}}`;
  }

  // Método para migrar proyecto antiguo al nuevo formato
  migrarProyectoAntiguo() {
    // Los proyectos antiguos NO se migran automáticamente
    // Se mantienen en formato de atributos únicos
    // Solo se migran si el usuario explícitamente marca el checkbox
    if (!this.proyect.isMultipleVivienda && this.proyect.attributes) {
      // Mantener el checkbox desmarcado para proyectos antiguos
      this.isMultipleVivienda?.patchValue(false);
    }
  }

  // Método para verificar si un proyecto está en blockchain
  isProjectInBlockchain(): boolean {
    return this.proyect?.blockchain === true;
  }

  // Método para verificar si un campo está bloqueado (solo lectura)
  isFieldBlocked(fieldName: string): boolean {
    if (!this.isProjectInBlockchain()) {
      return false; // Si no está en blockchain, todos los campos son editables
    }

    // Campos que SÍ se pueden editar en proyectos en blockchain
    const editableFields = [
      'descripcion',
      'urlWhitepaperPdf',
      'urlDosierPdf', 
      'urlInfoTokenPdf',
      'urlImagenPrincipal',
      'atributos',
      'infoProyecto',
      'iframeGoogleMaps',
      'calle',
      'localidad',
      'barrio',
      'codigoPostal',
      'rentabilidadAnual',
      'plazoEstimadoEntrega',
      'fechaActivado'
    ];

    return !editableFields.includes(fieldName);
  }

  // Método para configurar campos de solo lectura
  setupReadonlyFields(): void {
    this.projectInBlockchain = this.isProjectInBlockchain();
    
    if (this.projectInBlockchain) {
      // Deshabilitar campos críticos para proyectos en blockchain
      // Nota: titulo, promotora, pais y estadoCCAAProvincia están desbloqueados para permitir edición
      // Nota: iframeGoogleMaps, calle, localidad, barrio, codigoPostal, rentabilidadAnual, 
      //       plazoEstimadoEntrega, fechaActivado e infoProyecto ahora están desbloqueados
      const criticalFields = [
        'amountToSell', 'precioToken', 'inversionMinima',
        'stableCoinAddress', 'beneficiaryAddress', 'aggregatorStableCoinDolar',
        'toBlockchain', 'onlyInversors', 'percentageToPivateSale',
        'nameTokens', 'symbolTokens', 'managingInvestments'
      ];

      criticalFields.forEach(field => {
        const control = this.formNewNft.get(field);
        if (control) {
          control.disable();
        }
      });

      // Habilitar explícitamente los campos que ahora se pueden editar
      const nowEditableFields = [
        'iframeGoogleMaps',
        'calle',
        'localidad',
        'barrio',
        'codigoPostal',
        'rentabilidadAnual',
        'plazoEstimadoEntrega',
        'fechaActivado',
        'infoProyecto',
        'proyectStatus'
      ];

      nowEditableFields.forEach(field => {
        const control = this.formNewNft.get(field);
        if (control) {
          control.enable();
        }
      });
    } else {
      // Si el proyecto NO está en blockchain, asegurar que todos los campos estén habilitados
      const allFields = [
        'iframeGoogleMaps', 'calle', 'localidad', 'barrio', 'codigoPostal',
        'rentabilidadAnual', 'plazoEstimadoEntrega', 'fechaActivado', 'infoProyecto', 'proyectStatus'
      ];
      allFields.forEach(field => {
        const control = this.formNewNft.get(field);
        if (control) {
          control.enable();
        }
      });
    }
  }

  // Método para guardar solo los cambios sin actualizar todas las propiedades
  async saveChanges() {
    // Validar formulario principal (solo campos requeridos básicos)
    const requiredFields = ['titulo', 'promotora', 'pais', 'estadoCCAAProvincia', 'localidad', 'barrio', 'codigoPostal', 'calle', 'iframeGoogleMaps', 'descripcion'];
    let hasErrors = false;
    
    requiredFields.forEach(field => {
      const control = this.formNewNft.get(field);
      if (control && control.invalid && (control.dirty || control.touched)) {
        control.markAsTouched();
        hasErrors = true;
      }
    });

    if (hasErrors) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos requeridos',
        text: 'Por favor, completa los campos obligatorios antes de guardar.'
      });
      return;
    }

    // Validar primera vivienda si es proyecto con múltiples viviendas
    if (this.isMultipleVivienda?.getRawValue()) {
      if (this.primeraVivienda.invalid) {
        this.primeraVivienda.markAllAsTouched();
        Swal.fire({
          icon: 'warning',
          title: 'Validación de viviendas',
          text: 'Por favor, completa los datos de la primera vivienda.'
        });
        return;
      }

      // Validar viviendas adicionales
      if (this.viviendasArray.invalid) {
        this.viviendasArray.markAllAsTouched();
        Swal.fire({
          icon: 'warning',
          title: 'Validación de viviendas',
          text: 'Por favor, completa los datos de todas las viviendas.'
        });
        return;
      }
    } else {
      // Si no es múltiple vivienda, validar atributos
      if (this.atributos?.invalid) {
        this.atributos.markAsTouched();
        Swal.fire({
          icon: 'warning',
          title: 'Validación de atributos',
          text: 'Por favor, completa los atributos del proyecto.'
        });
        return;
      }
    }

    const imagesUrls: string[] = this.pushImages();
    const isMultipleVivienda = this.isMultipleVivienda?.getRawValue();
    
    let viviendas = null;
    let atributos = null;

    if (isMultipleVivienda) {
      viviendas = this.getAllViviendas();
    } else {
      atributos = this.getAtributosJsonFromString(this.atributos?.value || '{}');
    }

    // Preparar solo los campos editables para actualizar
    const updates: any = {
      title: this.titulo?.getRawValue(),
      company: this.promotora?.getRawValue(),
      country: this.pais?.getRawValue(),
      stateCCAAProvince: this.estadoCCAAProvincia?.getRawValue(),
      location: this.localidad?.getRawValue(),
      neighborhood: this.barrio?.getRawValue(),
      cp: this.codigoPostal?.getRawValue(),
      street: this.calle?.getRawValue(),
      iframeGoogleMaps: this.iframeGoogleMaps?.getRawValue(),
      description: this.descripcion?.getRawValue(),
      estimatedDeliveryTime: this.plazoEstimadoEntrega?.getRawValue(),
      annualReturn: this.rentabilidadAnual?.getRawValue(),
      infoProyecto: this.infoProyecto?.getRawValue(),
      propertyType: this.propertyType?.getRawValue() || 'House Flipping', // Tipo de propiedad con fallback
      isMultipleVivienda: isMultipleVivienda,
      ...(isMultipleVivienda ? { viviendas: viviendas } : { attributes: atributos }),
      mainImage: this.fotoMain,
      images: imagesUrls,
      proyectStatus: this.proyectStatus?.getRawValue()
    };

    // Agregar documentos solo si se han subido nuevos
    if (this.whitePaper) {
      updates.urlWhitepapperPdf = this.whitePaper;
    }
    if (this.dosier) {
      updates.urlDosierPdf = this.dosier;
    }
    if (this.infoToken) {
      updates.urlInfoTokenPdf = this.infoToken;
    }

    // Agregar fecha de activación si existe
    if (this.fechaActivado?.getRawValue()) {
      updates.activationDate = new Date(this.fechaActivado.getRawValue());
    }

    // Si el proyecto NO está en blockchain, también permitir actualizar estos campos
    if (!this.isProjectInBlockchain()) {
      if (this.amountToSell?.getRawValue() !== undefined) {
        updates.amountToSell = this.amountToSell?.getRawValue();
      }
      if (this.precioToken?.getRawValue() !== undefined) {
        updates.priceToken = this.precioToken?.getRawValue() * 100;
      }
      if (this.inversionMinima?.getRawValue() !== undefined) {
        updates.minimumInvestment = this.inversionMinima?.getRawValue();
      }
      if (this.stableCoinAddress?.getRawValue() !== undefined) {
        updates.stableCoinAddress = this.stableCoinAddress?.getRawValue();
      }
      if (this.beneficiaryAddress?.getRawValue() !== undefined) {
        updates.beneficiaryAddress = this.beneficiaryAddress?.getRawValue();
      }
      if (this.aggregatorStableCoinDolar?.getRawValue() !== undefined) {
        updates.aggregatorStableCoinDolar = this.aggregatorStableCoinDolar?.getRawValue();
      }
      if (this.nameTokens?.getRawValue() !== undefined) {
        updates.nameTokens = this.nameTokens?.getRawValue();
      }
      if (this.symbolTokens?.getRawValue() !== undefined) {
        updates.symbolTokens = this.symbolTokens?.getRawValue();
      }
      if (this.onlyInversors?.getRawValue() !== undefined) {
        updates.onlyInversors = this.onlyInversors?.getRawValue();
      }
      if (this.managingInvestments?.getRawValue() !== undefined) {
        updates.managingInvestments = this.managingInvestments?.getRawValue();
      }
      if (this.onlyInversors?.getRawValue() && this.percentageToPivateSale?.getRawValue() !== undefined) {
        updates.percentageToPrivateSale = this.percentageToPivateSale?.getRawValue();
      }
    }

    // Actualizar solo los campos modificados, sin resetear propiedades existentes
    this.afs.collection('investments').doc(this.proyect.id).update(updates)
      .then(() => {
        Swal.fire({
          icon: 'success',
          text: `Cambios guardados correctamente`
        });
      })
      .catch((err: any) => { 
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo ha ido mal al guardar los cambios!'
        });
      });
  }

  // Propiedad para controlar si se guardan los cambios al actualizar
  saveOnUpdate: boolean = true;

  async newNft() {
    if (!this.onlyInversors?.value) {
      this.formNewNft.removeControl('percentageToPivateSale');   
    } 
    
    // Validar formulario principal
    if (this.formNewNft.invalid) { 
      this.formNewNft.markAllAsTouched();
      return; 
    }

    // Validar primera vivienda
    if (this.primeraVivienda.invalid) {
      this.primeraVivienda.markAllAsTouched();
      return;
    }

    // Validar viviendas adicionales
    if (this.viviendasArray.invalid) {
      this.viviendasArray.markAllAsTouched();
      return;
    }

    const imagesUrls: string[] = this.pushImages();
    const isMultipleVivienda = this.isMultipleVivienda?.getRawValue();
    
    let viviendas = null;
    let atributos = null;

    if (isMultipleVivienda) {
      viviendas = this.getAllViviendas();
    } else {
      atributos = this.getAtributosJsonFromString(this.atributos?.value || '{}');
    }

    // Si el proyecto está en blockchain, solo actualizar campos seguros
    if (this.isProjectInBlockchain()) {
      const safeUpdates: any = {
        id: this.proyect.id,
        description: this.descripcion?.getRawValue(),
        urlWhitepapperPdf: this.whitePaper,
        urlDosierPdf: this.dosier,
        urlInfoTokenPdf: this.infoToken,
        isMultipleVivienda: isMultipleVivienda,
        ...(isMultipleVivienda ? { viviendas: viviendas } : { attributes: atributos }),
        mainImage: this.fotoMain,
        images: imagesUrls,
        infoProyecto: this.infoProyecto?.getRawValue(),
        proyectStatus: this.proyectStatus?.getRawValue()
      };

      // Actualizar solo los campos seguros
      this.afs.collection('investments').doc(this.proyect.id).update(safeUpdates)
        .then(() => {
          Swal.fire({
            icon: 'success',
            text: `Proyecto actualizado (solo campos seguros)`
          }).then(() => {
            this.close.emit(true);
          });
        })
        .catch((err: any) => { 
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Algo ha ido mal!'
          });
        });
      return;
    }

    // Si NO se deben guardar los cambios en la BBDD (solo actualizar en blockchain si aplica)
    if (!this.saveOnUpdate) {
      if (this.toBlockchain?.getRawValue() === true) {
        // Si va a blockchain, procedemos directamente a la blockchain
        // NOTA: addProyectToBlockchain usa los valores del formulario actual por defecto?
        // Revisando addProyectToBlockchain, usa this.amountToSell?.getRawValue(), etc.
        // Así que usará los valores actuales del formulario aunque no estén guardados en BBDD.
        const _id = this.proyect.id;
        this.addProyectToBlockchain(_id);
      } else {
        // Si no va a blockchain y no guardamos en BBDD, simplemente cerramos o avisamos
        // En este caso, asumimos que el usuario quería "Actualizar" pero sin persistir, lo cual es raro si no es blockchain.
        // Pero cerramos para cumplir "no guardar".
         Swal.fire({
            icon: 'info',
            text: `No se han guardado cambios en la BBDD (opción desactivada)`
          }).then(() => {
            this.close.emit(true);
          });
      }
      return;
    }

    // Para proyectos no desplegados, usar la lógica original (Guardar en BBDD)
    const item: any = {
      id: this.proyect.id,
      title: this.titulo?.getRawValue(),
      company: this.promotora?.getRawValue(),
      country: this.pais?.getRawValue(),
      stateCCAAProvince: this.estadoCCAAProvincia?.getRawValue(),
      location: this.localidad?.getRawValue(),
      neighborhood: this.barrio?.getRawValue(),
      cp: this.codigoPostal?.getRawValue(),
      street: this.calle?.getRawValue(),
      iframeGoogleMaps: this.iframeGoogleMaps?.getRawValue(),
      description: this.descripcion?.getRawValue(),
      estimatedDeliveryTime: this.plazoEstimadoEntrega?.getRawValue(),
      annualReturn: this.rentabilidadAnual?.getRawValue(),
      // Preserva amountSold existente al editar; default 0 al crear. Evita resetear progreso.
      amountSold: this.proyect?.amountSold ?? 0,
      amountToSell: this.amountToSell?.getRawValue(),
      priceToken: this.precioToken?.getRawValue() * 100,
      minimumInvestment: this.inversionMinima?.getRawValue(),
      stableCoinAddress: this.stableCoinAddress?.getRawValue(),
      beneficiaryAddress: this.beneficiaryAddress?.getRawValue(),
      aggregatorStableCoinDolar: this.aggregatorStableCoinDolar?.getRawValue(),
      urlWhitepapperPdf: this.whitePaper,
      urlDosierPdf: this.dosier,
      urlInfoTokenPdf: this.infoToken,
      proyectStatus: 'En estudio',
      isMultipleVivienda: isMultipleVivienda,
      ...(isMultipleVivienda ? { viviendas: viviendas } : { attributes: atributos }),
      blockchain: this.toBlockchain?.getRawValue(),
      onlyInversors: this.onlyInversors?.getRawValue(),
      nameTokens: this.nameTokens?.getRawValue(),
      symbolTokens: this.symbolTokens?.getRawValue(),
      mainImage: this.fotoMain,
      images: imagesUrls,
      sellerAddress: null,
      tokensAddress: null,
      dividendsAddress: null,
      NftID: null,
      endOfSale: 0,
      numberInvestors: 0,
      hoursToSell: 0,
      infoProyecto: this.infoProyecto?.getRawValue(),
      propertyType: this.propertyType?.getRawValue() || 'House Flipping', // Tipo de propiedad con fallback
      activationDate: this.fechaActivado?.getRawValue() ? new Date(this.fechaActivado.getRawValue()) : null,
      managingInvestments: this.managingInvestments?.getRawValue(),
      ...(this.onlyInversors?.getRawValue() ? { percentageToPrivateSale: this.percentageToPivateSale?.getRawValue() } : {})
    };
    
    this.addInvestment(item);
  }

  addInvestment(item: any) {
    this.afs.collection('investments').doc(this.proyect.id).set(item, {merge: true})
      .then(() => {
        if (this.toBlockchain?.getRawValue() === true) {
          const _id = this.proyect.id;
          this.addProyectToBlockchain(_id);
        } else {
          Swal.fire({
            icon: 'success',
            text: `Proyecto subido a la BBDD (No blockchain)`
          }).then(() => {
            this.close.emit(true);
          })
        }
      })
      .catch((err: any) => { 
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo ha ido mal!'
        });
      });
  }

  async addProyectToBlockchain(id: string) {    
    Swal.fire({
      title: 'Procesando...',
      html: 'No cierres esta pantalla!!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    const baseFee: number = await this.web3.eth.getBlock('pending').then((block: any) => { 
      return Number(block.baseFeePerGas) + 100000000000; 
    });

    this.contractManager.methods.mintNft(
      this.formatToWei(this.amountToSell?.getRawValue()),
      id,
      this.stableCoinAddress?.getRawValue(),
      this.beneficiaryAddress?.getRawValue(),
      this.aggregatorStableCoinDolar?.getRawValue(),
      this.nameTokens?.getRawValue(),
      this.symbolTokens?.getRawValue() 
    ).send({from: this.ourAddress, maxFeePerGas: this.web3.utils.toHex(baseFee), maxPriorityFeePerGas: this.web3.utils.toHex(this.web3.utils.toWei('50', 'gwei'))})
      .then(() => {
        this.web3.eth.getBlockNumber().then((res: any) => {
          const blockNumber: number = res;

          this.contractManager.getPastEvents('newMint', {
            fromBlock: blockNumber - 8
          }, (err: any, events: any) => {
            const e = events[0];
  
            if (this.web3.utils.sha3(id) === e.returnValues.uri) {
              this.afs.collection('investments').doc(id).set({
                sellerAddress: e.returnValues.e_seller,
                tokensAddress: e.returnValues.e_holdings,
                dividendsAddress: e.returnValues.e_dividends,
                NftID: e.returnValues.e_NftID
              }, {merge: true}).then(() => {
                Swal.close();
                Swal.fire({
                  icon: 'success',
                  text: `Proyecto subido a la BBDD y a la Blockchain`
                }).then(() => { this.close.emit(true); });
              });
            }
          });
        });
      })
      .catch((err: any) => {
        this.afs.collection('investments').doc(id).set({
          blockchain: false
        }, {merge: true});

        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Transacción errónea',
          text: 'Algo ha ido mal, la transacción NO se ha realizado'
        });
      });
  }

  formatToWei(num: number) {
    return this.web3.utils.toWei(num.toString(), 'ether');
  }

  pushImages(): string[] {
    let images: string[] = [];

    (this.foto1 !== null) ? images.push(this.foto1) : null;
    (this.foto2 !== null) ? images.push(this.foto2) : null;
    (this.foto3 !== null) ? images.push(this.foto3) : null;
    (this.foto4 !== null) ? images.push(this.foto4) : null;
    (this.foto5 !== null) ? images.push(this.foto5) : null;
    (this.foto6 !== null) ? images.push(this.foto6) : null;
    (this.foto7 !== null) ? images.push(this.foto7) : null;
    (this.foto8 !== null) ? images.push(this.foto8) : null;
    (this.foto9 !== null) ? images.push(this.foto9) : null;
    (this.foto10 !== null) ? images.push(this.foto10) : null;

    return images;
  }


  uploadImg(e: any, id: string) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.proyect.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe((res: string) => {
          (id === 'fotoPrincipal') ? this.fotoMain = res : null;
          (id === 'foto1') ? this.foto1 = res : null;
          (id === 'foto2') ? this.foto2 = res : null;
          (id === 'foto3') ? this.foto3 = res : null;
          (id === 'foto4') ? this.foto4 = res : null;
          (id === 'foto5') ? this.foto5 = res : null;
          (id === 'foto6') ? this.foto6 = res : null;
          (id === 'foto7') ? this.foto7 = res : null;
          (id === 'foto8') ? this.foto8 = res : null;
          (id === 'foto9') ? this.foto9 = res : null;
          (id === 'foto10') ? this.foto10 = res : null;
          this.loadingFlag = false;
          this.cdr.detectChanges();
        });
      })).subscribe();
  }

  uploadWhitepaper(e: any) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.proyect.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe((res: string) => {
          this.whitePaper = res;
          this.loadingFlag = false;
        })
      })).subscribe();
  }

  uploadDosier(e: any) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.proyect.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe((res: string) => {
          this.dosier = res;
          this.loadingFlag = false;
        })
      })).subscribe();
  }

  uploadInfoToken(e: any) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.proyect.id}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe((res: string) => {
          this.infoToken = res;
          this.loadingFlag = false;
        })
      })).subscribe();
  }

  ngOnInit(): void {
    this.titulo?.patchValue(this.proyect.title);
    this.promotora?.patchValue(this.proyect.company);
    this.pais?.patchValue(this.proyect.country);
    this.estadoCCAAProvincia?.patchValue(this.proyect.stateCCAAProvince);
    this.localidad?.patchValue(this.proyect.location);
    this.barrio?.patchValue(this.proyect.neighborhood);
    this.codigoPostal?.patchValue(this.proyect.cp);
    this.calle?.patchValue(this.proyect.street);
    this.iframeGoogleMaps?.patchValue(this.proyect.iframeGoogleMaps);
    this.descripcion?.patchValue(this.proyect.description);
    this.plazoEstimadoEntrega?.patchValue(this.proyect.estimatedDeliveryTime);
    this.rentabilidadAnual?.patchValue(this.proyect.annualReturn);
    this.amountToSell?.patchValue(this.proyect.amountToSell);
    this.precioToken?.patchValue(this.proyect.priceToken / 100);
    this.inversionMinima?.patchValue(this.proyect.minimumInvestment);
    this.stableCoinAddress?.patchValue(this.proyect.stableCoinAddress);
    this.beneficiaryAddress?.patchValue(this.proyect.beneficiaryAddress);
    this.aggregatorStableCoinDolar?.patchValue(this.proyect.aggregatorStableCoinDolar);
    this.onlyInversors?.patchValue(this.proyect.onlyInversors);
    this.percentageToPivateSale?.patchValue(this.proyect.percentageToPrivateSale);
    this.nameTokens?.patchValue(this.proyect.nameTokens);
    this.symbolTokens?.patchValue(this.proyect.symbolTokens);
    this.propertyType?.patchValue(this.proyect.propertyType || 'House Flipping'); // Cargar tipo de propiedad con fallback
    this.infoProyecto?.patchValue(this.proyect.infoProyecto);
    this.managingInvestments?.patchValue(this.proyect.managingInvestments || false);
    this.proyectStatus?.patchValue(this.proyect.proyectStatus);
    
    // Determinar si es proyecto con viviendas múltiples
    const isMultipleVivienda = this.proyect.isMultipleVivienda === true;
    this.isMultipleVivienda?.patchValue(isMultipleVivienda);
    
    // Cargar atributos si es formato antiguo
    if (!isMultipleVivienda && this.proyect.attributes) {
      let attributesString;
      if (typeof this.proyect.attributes === 'string') {
        attributesString = this.proyect.attributes;
      } else {
        attributesString = JSON.stringify(this.proyect.attributes);
      }

      if (attributesString.startsWith('{') && attributesString.endsWith('}')) {
        attributesString = attributesString.substring(1, attributesString.length - 1);
      }
      
      this.atributos?.patchValue(attributesString);
    }
    if (this.proyect.activationDate) {
      let date;
      if (this.proyect.activationDate.toDate) {
        date = this.proyect.activationDate.toDate();
      } else if (this.proyect.activationDate instanceof Date) {
        date = this.proyect.activationDate;
      } else {
        date = new Date(this.proyect.activationDate);
      }
      
      const offset = date.getTimezoneOffset();
      const localDate = new Date(date.getTime() - (offset * 60 * 1000));
      const formattedDate = localDate.toISOString().slice(0, 16);
      this.fechaActivado?.patchValue(formattedDate);
    }

    if (this.proyect.urlWhitepapperPdf !== undefined && this.proyect.urlWhitepapperPdf !== null && this.proyect.urlWhitepapperPdf !== '') {
      this.whitePaper = this.proyect.urlWhitepapperPdf;
    }

    if (this.proyect.urlDosierPdf !== undefined && this.proyect.urlDosierPdf !== null && this.proyect.urlDosierPdf !== '') {
      this.dosier = this.proyect.urlDosierPdf;
    }

    if (this.proyect.urlInfoTokenPdf !== undefined && this.proyect.urlInfoTokenPdf !== null && this.proyect.urlInfoTokenPdf !== '') {
      this.infoToken = this.proyect.urlInfoTokenPdf;
    }

    // Cargar viviendas existentes
    this.cargarViviendasExistentes();
    
    // Migrar proyecto antiguo si es necesario
    this.migrarProyectoAntiguo();

    if (this.proyect.mainImage !== undefined && this.proyect.mainImage !== null && this.proyect.mainImage !== '') {
      this.fotoMain = this.proyect.mainImage;
    }

    for (let i = 0; i < this.proyect.images.length; i++) {
      (i === 0) ? this.foto1 = this.proyect.images[0] : null;
      (i === 1) ? this.foto2 = this.proyect.images[1] : null;
      (i === 2) ? this.foto3 = this.proyect.images[2] : null;
      (i === 3) ? this.foto4 = this.proyect.images[3] : null;
      (i === 4) ? this.foto5 = this.proyect.images[4] : null;
      (i === 5) ? this.foto6 = this.proyect.images[5] : null;
      (i === 6) ? this.foto7 = this.proyect.images[6] : null;
      (i === 7) ? this.foto8 = this.proyect.images[7] : null;
      (i === 8) ? this.foto9 = this.proyect.images[8] : null;
      (i === 9) ? this.foto10 = this.proyect.images[9] : null;
    }

    // Configurar campos de solo lectura después de cargar los datos
    this.setupReadonlyFields();
  }

  async deleteProyect() {
    // Paso 1: Primera confirmación
    const firstResult = await Swal.fire({
      title: '¿Estás seguro?',
      text: "Esta acción eliminará el proyecto y todas sus imágenes. Esta acción no se puede deshacer",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    });

    if (!firstResult.isConfirmed) {
      return;
    }

    // Paso 2: Segunda confirmación (varía si está en blockchain o no)
    let secondResult;

    if (this.isProjectInBlockchain()) {
      secondResult = await Swal.fire({
        title: '⚠️ ADVERTENCIA CRÍTICA',
        html: `Este proyecto está <b>DESPLEGADO EN BLOCKCHAIN</b>.<br><br>
               Eliminarlo de la web <b>NO LO ELIMINARÁ</b> de la Blockchain, pero desaparecerá de tu panel de administración.<br><br>
               Para confirmar, escribe <b>ELIMINAR</b> en el campo de abajo:`,
        input: 'text',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Entiendo, ELIMINAR PROYECTO',
        cancelButtonText: 'Cancelar',
        preConfirm: (value) => {
          if (value !== 'ELIMINAR') {
            Swal.showValidationMessage('Debes escribir "ELIMINAR" exactamente para confirmar.');
          }
        }
      });
    } else {
      secondResult = await Swal.fire({
        title: 'Confirmación final',
        text: "¿Realmente quieres eliminar este proyecto definitivamente?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar definitivamente',
        cancelButtonText: 'Cancelar'
      });
    }

    if (!secondResult.isConfirmed) {
      return;
    }

    try {
      // Mostrar loading
      Swal.fire({
        title: 'Eliminando...',
        text: 'Por favor espera mientras se elimina el proyecto y sus archivos',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Eliminar imágenes del storage
      await this.deleteProjectImages();

      // Eliminar el documento de Firestore
      await this.afs.collection('investments').doc(this.proyect.id).delete();

      Swal.fire(
        'Eliminado',
        'El proyecto y sus archivos han sido eliminados.',
        'success'
      ).then(() => {
        this.close.emit(true);
      });
    } catch (error) {
      console.error('Error eliminando proyecto:', error);
      Swal.fire(
        'Error',
        'No se pudo eliminar el proyecto completamente. Algunos archivos pueden quedar en el storage.',
        'error'
      );
    }
  }

  // Método para eliminar todas las imágenes del proyecto
  private async deleteProjectImages(): Promise<void> {
    const projectId = this.proyect.id;
    const imagesToDelete: Promise<void>[] = [];

    // Eliminar imagen principal
    if (this.proyect.mainImage) {
      try {
        const mainImageRef = this.storage.refFromURL(this.proyect.mainImage);
        imagesToDelete.push(
          mainImageRef.delete().toPromise().catch(err => {
            console.warn('Error eliminando imagen principal:', err);
          })
        );
      } catch (error) {
        console.warn('Error obteniendo referencia de imagen principal:', error);
      }
    }

    // Eliminar imágenes adicionales
    if (this.proyect.images && Array.isArray(this.proyect.images)) {
      this.proyect.images.forEach((imageUrl: string) => {
        if (imageUrl) {
          try {
            const imageRef = this.storage.refFromURL(imageUrl);
            imagesToDelete.push(
              imageRef.delete().toPromise().catch(err => {
                console.warn('Error eliminando imagen:', err);
              })
            );
          } catch (error) {
            console.warn('Error obteniendo referencia de imagen:', error);
          }
        }
      });
    }

    // Eliminar documentos PDF
    if (this.proyect.urlWhitepapperPdf) {
      try {
        const whitepaperRef = this.storage.refFromURL(this.proyect.urlWhitepapperPdf);
        imagesToDelete.push(
          whitepaperRef.delete().toPromise().catch(err => {
            console.warn('Error eliminando whitepaper:', err);
          })
        );
      } catch (error) {
        console.warn('Error obteniendo referencia de whitepaper:', error);
      }
    }

    if (this.proyect.urlDosierPdf) {
      try {
        const dosierRef = this.storage.refFromURL(this.proyect.urlDosierPdf);
        imagesToDelete.push(
          dosierRef.delete().toPromise().catch(err => {
            console.warn('Error eliminando dosier:', err);
          })
        );
      } catch (error) {
        console.warn('Error obteniendo referencia de dosier:', error);
      }
    }

    if (this.proyect.urlInfoTokenPdf) {
      try {
        const infoTokenRef = this.storage.refFromURL(this.proyect.urlInfoTokenPdf);
        imagesToDelete.push(
          infoTokenRef.delete().toPromise().catch(err => {
            console.warn('Error eliminando info token:', err);
          })
        );
      } catch (error) {
        console.warn('Error obteniendo referencia de info token:', error);
      }
    }

    // Esperar a que se eliminen todos los archivos
    await Promise.all(imagesToDelete);
  }

  winAnsiValidator(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    if (!value) return null;
    // Characters mapped in Windows-1252 0x80–0x9F range that are valid
    const win1252Special = new Set([
      0x20AC, 0x201A, 0x0192, 0x201E, 0x2026, 0x2020, 0x2021, 0x02C6,
      0x2030, 0x0160, 0x2039, 0x0152, 0x017D, 0x2018, 0x2019, 0x201C,
      0x201D, 0x2022, 0x2013, 0x2014, 0x02DC, 0x2122, 0x0161, 0x203A,
      0x0153, 0x017E, 0x0178
    ]);
    for (const char of String(value)) {
      const cp = char.codePointAt(0)!;
      if (cp > 255 && !win1252Special.has(cp)) {
        return { 'invalidWinAnsi': { invalidChar: char } };
      }
    }
    return null;
  }

  urlValidator(control: AbstractControl): { [key: string]: any } | null {
    const validUrlRegex = /^(ftp|http|https):\/\/(?:(?:[a-z0-9][a-z0-9-]*[a-z0-9]\.)+[a-z]{2,}|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(?::[0-9]{1,5})?(?:\/[^\s]*)?$/i;
    const value = control.value;
    const isValid = validUrlRegex.test(value);
    return isValid ? null : { 'invalidUrl': { value } };
  }
}
